import React, { useState, useEffect } from "react";

export const LoadingScreen = ({ loading }) => {

    const [show, setShow] = React.useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setShow(true);
        }, 50)

        return () => clearTimeout(timeout);
    }, [show]);

    if (!show) return null;

    return (  
		<div>
            {loading ? (
                 <div class="loader-wrapper loading-container">
                 <div class="truck-wrapper">
                   <div class="truck">
                     <div class="truck-container"></div>
                     <div class="glases"></div>
                     <div class="bonet"></div>
                 
                     <div class="base"></div>
                 
                     <div class="base-aux"></div>
                     <div class="wheel-back"></div>
                     <div class="wheel-front"></div>
                 
                     <div class="smoke"></div>
                   </div>
                 </div>
                 </div>
            ) : null}
        </div>
    );
};